var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.81,
    height: 12.075,
    viewBox: "0 0 22.81 12.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#435877;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.19 -64.605)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.78,79.3l-5.847-5.307,5.847-5.355",
    transform: "translate(-13 -3.324)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 21,
    transform: "translate(16.5 70.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetour);
export default __webpack_public_path__ + "static/media/retour.39abbe3a210cdb6570265e33ca9ec57b.svg";
export { ForwardRef as ReactComponent };